import graphql__61ea430f843787fee0ad from "./__generated__/FinalizeInvoiceDialog_invoice.graphql.ts";
import graphql__fb94df7c1eed60cf2c9c from "./__generated__/FinalizeInvoiceDialogFinalizeInvoiceMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import Hint from "../presentational/Hint";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type FinalizeInvoiceDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const FinalizeInvoiceDialog: React.FC<FinalizeInvoiceDialogProps> = (props) => {

    const navigate = useNavigate();
    const intl = useIntl();
    const invoice = useFragment(
        graphql__61ea430f843787fee0ad,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__fb94df7c1eed60cf2c9c,
                variables: {
                    input: {
                        id: input.id
                    }
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                    navigate('/invoices/' + invoice.id)
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToFinalizeInvoice'})
            }
        )
    }

    const initialValues = {
        id: invoice.id
    }

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} headline={intl.formatMessage({id: 'dialog.FinalizeInvoiceDialog.headline'})} submitLabel={intl.formatMessage({id: 'dialog.FinalizeInvoiceDialog.submitLabel'})}>
            <Section>
                <Row>
                    <div className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.FinalizeInvoiceDialog.question'}, {customer: invoice.customerAccount.customerName})}
                    </div>
                    <Hint className="pt-4">{intl.formatMessage({id: 'dialog.FinalizeInvoiceDialog.hint'})}</Hint>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default FinalizeInvoiceDialog;
